"use client";

import extractImages from "@/lib/tiptap/utils/extractImages";
import { useState } from "react";

export default function Expandable({
  children,
  content,
  limit = 4,
  collapsedHeight = 400,
  buttonClassName = "btn btn-primary",
}: any) {
  const [expanded, setExpanded] = useState(false);

  const length = content.content?.length;

  const containsMedia = extractImages(content).length > 0;

  const shouldTruncate = length - limit >= 2 || containsMedia;

  return (
    <div className="relative">
      <div
        style={{
          maxHeight: !shouldTruncate || expanded ? "none" : collapsedHeight,
        }}
        className="relative transition-[max-height] duration-300 ease-in-out overflow-hidden"
      >
        {children}

        {/* Fade + knapp endast när vi inte expanderat */}
        {shouldTruncate && !expanded && (
          <div className="absolute bottom-0 left-0 w-full h-24 flex flex-col items-center justify-end bg-gradient-to-t from-sand-500 to-transparent z-10">
            <button
              type="button"
              onClick={() => setExpanded(true)}
              aria-expanded={expanded}
              className={buttonClassName}
            >
              Läs mer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
